import { Label } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import '../CasesConfirmationForm/confirmation-form.scss';
import i18n from 'i18n';
import DynamicForm, { ChangedField } from '../../../../../shared/form';
import { TargetsMap } from '../CasesConfirmationForm/CasesConfirmationForm';

interface TargetValueProps {
  primaryType: string;
  primaryValue: string;
  targetsMap: TargetsMap;
  setIsValid: (targetsMap: TargetsMap) => void;
  caseNumber: number;
  isRequired?: boolean;
}

const TargetValue = ({
  primaryType,
  primaryValue,
  targetsMap,
  setIsValid,
  caseNumber,
  isRequired,
}: TargetValueProps): JSX.Element => {
  const [matched, setMatched] = useState(false);
  const confirmFieldKey = `confirm${primaryType}`;

  const fields = {
    [primaryType]: {
      label: (primaryType as string),
      type: 'password',
      initial: primaryValue as string,
      disabled: true,
      validation: {
        required: isRequired ?? false
      },
    },
    [confirmFieldKey]: {
      label: `Confirm ${primaryType} Value`,
      type: 'text',
      initial: '',
      disabled: false,
      validation: {
        required: isRequired ?? false
      },
    },
  };

  useEffect(() => {
    if (primaryValue === '') {
      setMatched(true);
    }
  }, [primaryType, primaryValue]);

  useEffect(() => {
    setMatched(false);
  }, [caseNumber])

  const handleDynamicFormUpdate = (changedField: ChangedField) => {
    if (changedField.value === primaryValue) {
      const newTargetsMap = { ...targetsMap, [primaryType]: true };
      setIsValid(newTargetsMap);
      setMatched(true);
    } else {
      const newTargetsMap = { ...targetsMap, [primaryType]: false };
      setIsValid(newTargetsMap);
      setMatched(false);
    }
  };

  const renderForm = () => {
    return (
      <DynamicForm
        key={caseNumber}
        fields={fields}
        name="confirmTargetValueField"
        layout={[[primaryType], [confirmFieldKey]]}
        i18nKeyPrefix="confirmation.form"
        fieldUpdateHandler={handleDynamicFormUpdate}
      />
    );
  };

  return (
    <div className="formField">
      {renderForm()}
      {!matched && (
        <Label className="field-error-message">
          {i18n.t('warrant.target.form.targetIdValidationError')}
        </Label>
      )}
    </div>
  );
};

export default TargetValue;
